import React from "react";
import {
  Box,
  Grid,
  Container,
  Avatar,
  Card,
  CardActionArea,
  CardContent,
  CardMedia,
  Hidden,
  Divider,
} from "@mui/material";
import Typography from "@mui/material/Typography";
import windowInst from "../assets/icons8-open-window-96.png";
import shovel from "../assets/icons8-spade-100.png";
import { orange } from "@mui/material/colors";
import { Fade } from "react-awesome-reveal";
import BathroomIcon from "@mui/icons-material/Bathroom";
import ElectricalServicesIcon from "@mui/icons-material/ElectricalServices";
import GavelIcon from "@mui/icons-material/Gavel";
import { Link } from "react-router-dom";
import HvacIcon from "@mui/icons-material/Hvac";
import FormatPaintIcon from "@mui/icons-material/FormatPaint";
import RoofingIcon from "@mui/icons-material/Roofing";
import PoolIcon from "@mui/icons-material/Pool";
import YardIcon from "@mui/icons-material/Yard";

const Categories = () => {
  //sx={{ minHeight: "100vh" }}
  return (
    <>
      <Box
        sx={[
          { mx: 2, my: 4, minHeight: "100vh", padding: "10rem 0" },
          (theme) => ({
            [theme.breakpoints.down("sm")]: {
              mx: 2,
              my: 3,
            },
          }),
          (theme) => ({
            [theme.breakpoints.down("md")]: {
              mx: 1,
              my: 3,
            },
          }),
        ]}
      >
        {" "}
        {/* //#FF9800 */}
        <Divider />
        <Typography
          variant="h1"
          component="h2"
          className="text-3xl uppercase font-extrabold text-center py-12 md:py-20 "
        >
          Categories
        </Typography>
        <Grid
          container
          item
          spacing={{ xs: 2, md: 4 }}
          // columns={{ xs: 4, sm: 8, md: 12 }}
        >
          <Grid
            className="lg:w-1/5 md:w-2/6 sm:w-2/4"
            sx={[
              { px: 2 },
              (theme) => ({
                [theme.breakpoints.down("sm")]: {
                  width: "50%",
                  py: 3,
                },
              }),
            ]}
          >
            <Fade delay={1000} direction="left">
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                {/* <Avatar
                  alt="Worship"
                  variant={"rounded"}
                  sx={{ width: 60, height: 60 }}
                  src={images}
                /> */}
                <GavelIcon sx={{ width: 60, height: 60 }} />
                <Link to={"/contractor"}>
                  <Typography py={2} px={2} color="green" variant="h4">
                    Contractor
                  </Typography>{" "}
                </Link>
                {/* <Typography
                  textAlign="center"
                  py={2}
                  px={2}
                  variant="body1"
                  component={"p"}
                >
                  Far far away, behind the word mountains, far from the
                  countries Vokalia and Consonantia, there live the blind texts
                </Typography> */}
              </Box>
            </Fade>
          </Grid>
          <Grid
            className="lg:w-1/5 md:w-2/6 sm:w-2/4"
            sx={[
              { px: 2 },
              (theme) => ({
                [theme.breakpoints.down("sm")]: {
                  width: "50%",
                  py: 3,
                },
              }),
            ]}
          >
            <Fade delay={2000} direction="down">
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                {/* <Avatar
                  alt="Worship"
                  variant={"rounded"}
                  sx={[{ width: 60, height: 60 }]}
                  src={images3}
                /> */}

                <BathroomIcon sx={[{ width: 60, height: 60 }]} />
                <Link to={"/plumber"}>
                  {" "}
                  <Typography
                    py={2}
                    textAlign="center"
                    //   px={2}
                    color="green"
                    variant="h4"
                  >
                    Plumber
                  </Typography>{" "}
                </Link>
              </Box>
            </Fade>
          </Grid>
          <Grid
            className="lg:w-1/5 md:w-2/6 sm:w-2/4"
            sx={[
              { px: 2 },
              (theme) => ({
                [theme.breakpoints.down("sm")]: {
                  width: "50%",
                  py: 3,
                },
              }),
            ]}
          >
            <Fade delay={3000} direction="down">
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                {/* <Avatar
                  alt="Worship"
                  variant={"rounded"}
                  sx={[{ width: 60, height: 60 }]}
                  src={images3}
                /> */}
                <HvacIcon sx={[{ width: 60, height: 60 }]} />
                <Link to={"/hvac"}>
                  <Typography
                    py={2}
                    textAlign="center"
                    //   px={2}
                    color="green"
                    variant="h4"
                  >
                    HVAC
                  </Typography>{" "}
                </Link>
              </Box>
            </Fade>
          </Grid>{" "}
          <Grid
            className="lg:w-1/5 md:w-2/6 sm:w-2/4"
            sx={[
              { px: 2 },
              (theme) => ({
                [theme.breakpoints.down("sm")]: {
                  width: "50%",
                  py: 3,
                },
              }),
              (theme) => ({
                [theme.breakpoints.down("md")]: {
                  py: 4,
                  px: 1,
                },
              }),
            ]}
          >
            <Fade delay={4000} direction="down">
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                {/* <Avatar
                  alt="Worship"
                  variant={"rounded"}
                  sx={[{ width: 60, height: 60 }]}
                  src={images3}
                /> */}
                <FormatPaintIcon sx={[{ width: 60, height: 60 }]} />
                <Link to={"/paint"}>
                  <Typography
                    py={2}
                    textAlign="center"
                    //   px={2}
                    color="green"
                    variant="h4"
                  >
                    Painter
                  </Typography>{" "}
                </Link>
              </Box>
            </Fade>
          </Grid>{" "}
          <Grid
            className="lg:w-1/5 md:w-2/6 sm:w-2/4"
            sx={[
              { px: 2 },
              (theme) => ({
                [theme.breakpoints.down("sm")]: {
                  width: "50%",
                  py: 3,
                },
              }),
              (theme) => ({
                [theme.breakpoints.down("md")]: {
                  py: 4,
                },
              }),
            ]}
          >
            <Fade delay={4000} direction="down">
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <Avatar
                  alt="Worship"
                  variant={"rounded"}
                  sx={[{ width: 60, height: 60 }]}
                  src={shovel}
                />
                <Link to={"/hvac"}>
                  {/* <HvacIcon sx={[{ width: 60, height: 60 }]} /> */}
                  <Typography
                    py={2}
                    textAlign="center"
                    //   px={2}
                    color="green"
                    variant="h4"
                  >
                    Tiler
                  </Typography>{" "}
                </Link>
              </Box>
            </Fade>
          </Grid>
          <Grid
            className="lg:w-1/5 md:w-2/6 sm:w-2/4"
            sx={[
              { py: 4 },
              (theme) => ({
                [theme.breakpoints.down("sm")]: {
                  width: "50%",
                  py: 3,
                },
              }),
              (theme) => ({
                [theme.breakpoints.down("md")]: {
                  py: 4,
                },
              }),
            ]}
          >
            <Fade delay={4000} direction="right">
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                {/* <Avatar
                  alt="Worship"
                  variant={"rounded"}
                  sx={{ width: 60, height: 60 }}
                  src={images2}
                /> */}
                <ElectricalServicesIcon
                  sx={{ width: 60, placeContent: "center", height: 60 }}
                />
                <Link to={"/electrical"}>
                  <Typography py={2} color="green" variant="h4">
                    Electrical Company
                  </Typography>{" "}
                </Link>
              </Box>
            </Fade>
          </Grid>
          <Grid
            className="lg:w-1/5 md:w-2/6 sm:w-2/4"
            sx={[
              { px: 2, py: 4 },
              (theme) => ({
                [theme.breakpoints.down("sm")]: {
                  width: "50%",
                  py: 3,
                },
              }),
              (theme) => ({
                [theme.breakpoints.down("md")]: {
                  py: 4,
                },
              }),
            ]}
          >
            <Fade delay={4000} direction="down">
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                {/* <Avatar
                  alt="Worship"
                  variant={"rounded"}
                  sx={[{ width: 60, height: 60 }]}
                  src={images3}
                /> */}
                <RoofingIcon sx={[{ width: 60, height: 60 }]} />
                <Link to={"/hvac"}>
                  <Typography
                    py={2}
                    textAlign="center"
                    //   px={2}
                    color="green"
                    variant="h4"
                  >
                    Pool Maintenance
                  </Typography>{" "}
                </Link>
              </Box>
            </Fade>
          </Grid>
          <Grid
            className="lg:w-1/5 md:w-2/6 sm:w-2/4"
            sx={[
              { px: 2, py: 4 },
              (theme) => ({
                [theme.breakpoints.down("sm")]: {
                  width: "50%",
                  py: 3,
                },
              }),
              (theme) => ({
                [theme.breakpoints.down("md")]: {
                  py: 4,
                },
              }),
            ]}
          >
            <Fade delay={4000} direction="down">
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <Avatar
                  alt="Worship"
                  variant={"rounded"}
                  sx={[{ width: 60, height: 60 }]}
                  src={windowInst}
                />
                {/* <HvacIcon sx={[{ width: 60, height: 60 }]} /> */}
                <Link to={"/hvac"}>
                  <Typography
                    py={2}
                    textAlign="center"
                    //   px={2}
                    color="green"
                    variant="h4"
                  >
                    Window Installer
                  </Typography>{" "}
                </Link>
              </Box>
            </Fade>
          </Grid>
          <Grid
            className="lg:w-1/5 md:w-2/6 sm:w-2/4"
            sx={[
              { px: 2, py: 4 },
              (theme) => ({
                [theme.breakpoints.down("sm")]: {
                  width: "50%",
                  py: 3,
                },
              }),
              (theme) => ({
                [theme.breakpoints.down("md")]: {
                  py: 4,
                },
              }),
            ]}
          >
            <Fade delay={4000} direction="down">
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <PoolIcon sx={[{ width: 60, height: 60 }]} />
                <Link to={"/hvac"}>
                  <Typography
                    py={2}
                    textAlign="center"
                    //   px={2}
                    color="green"
                    variant="h4"
                  >
                    Roofer
                  </Typography>{" "}
                </Link>
              </Box>
            </Fade>
          </Grid>
          <Hidden smDown>
            <Grid
              className="lg:w-1/5  sm:w-2/4"
              sx={[
                { px: 2, py: 4 },
                (theme) => ({
                  [theme.breakpoints.down("sm")]: {
                    width: "50%",
                    py: 3,
                  },
                }),
                (theme) => ({
                  [theme.breakpoints.down("md")]: {
                    py: 4,
                  },
                }),
              ]}
            >
              <Fade delay={4000} direction="down">
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <YardIcon sx={[{ width: 60, height: 60 }]} />
                  <Link to={"/hvac"}>
                    <Typography
                      py={2}
                      textAlign="center"
                      //   px={2}
                      color="green"
                      variant="h4"
                    >
                      Landscaping/gardening.
                    </Typography>{" "}
                  </Link>
                </Box>
              </Fade>
            </Grid>
          </Hidden>
          <Hidden smUp>
            <Grid
              className="lg:w-1/5  sm:w-2/4"
              sx={[
                { px: 2 },
                (theme) => ({
                  [theme.breakpoints.down("sm")]: {
                    width: "50%",
                    py: 3,
                  },
                }),
                (theme) => ({
                  [theme.breakpoints.down("md")]: {
                    py: 4,
                  },
                }),
              ]}
            >
              <Fade delay={4000} direction="down">
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <YardIcon sx={[{ width: 60, height: 60 }]} />
                  <Link to={"/hvac"}>
                    <Typography
                      py={2}
                      textAlign="center"
                      //   px={2}
                      color="green"
                      variant="h4"
                    >
                      gardening.
                    </Typography>{" "}
                  </Link>
                </Box>
              </Fade>
            </Grid>
          </Hidden>
        </Grid>
      </Box>

      {/* <Box
          sx={[
            { mx: 2, display: "flex", my: 4 },
            (theme) => ({
              [theme.breakpoints.down("sm")]: {
                mx: 2,
                my: 3,
              },
            }),
            (theme) => ({
              [theme.breakpoints.down("md")]: {
                mx: 1,
                my: 3,
              },
            }),
          ]}
        >
          <Box>
            <Card sx={{ maxWidth: 345 }}>
              <CardActionArea>
                <CardMedia
                  component="img"
                  height="140"
                  image="/static/images/cards/contemplative-reptile.jpg"
                  alt="green iguana"
                />
                <CardContent>
                  <Typography
                    gutterBottom
                    variant="h5"
                    textAlign={"center"}
                    component="div"
                  >
                    Lizard
                  </Typography>
                  <Typography variant="body2" color="text.secondary">
                    Lizards are a widespread group of squamate reptiles, with
                    over 6,000 species, ranging across all continents except
                    Antarctica
                  </Typography>
                </CardContent>
              </CardActionArea>
            </Card>
          </Box>
          <Box>
            <Card sx={{ maxWidth: 345 }}>
              <CardActionArea>
                <CardMedia
                  component="img"
                  height="140"
                  image="/static/images/cards/contemplative-reptile.jpg"
                  alt="green iguana"
                />
                <CardContent>
                  <Typography
                    gutterBottom
                    variant="h5"
                    textAlign={"center"}
                    component="div"
                  >
                    Lizard
                  </Typography>
                  <Typography variant="body2" color="text.secondary">
                    Lizards are a widespread group of squamate reptiles, with
                    over 6,000 species, ranging across all continents except
                    Antarctica
                  </Typography>
                </CardContent>
              </CardActionArea>
            </Card>
          </Box>
          <Box>
            <Card sx={{ maxWidth: 345 }}>
              <CardActionArea>
                <CardMedia
                  component="img"
                  height="140"
                  image="/static/images/cards/contemplative-reptile.jpg"
                  alt="green iguana"
                />
                <CardContent>
                  <Typography
                    gutterBottom
                    variant="h5"
                    textAlign={"center"}
                    component="div"
                  >
                    Lizard
                  </Typography>
                  <Typography variant="body2" color="text.secondary">
                    Lizards are a widespread group of squamate reptiles, with
                    over 6,000 species, ranging across all continents except
                    Antarctica
                  </Typography>
                </CardContent>
              </CardActionArea>
            </Card>
          </Box>
          <Box>
            <Card sx={{ maxWidth: 345 }}>
              <CardActionArea>
                <CardMedia
                  component="img"
                  height="140"
                  image="/static/images/cards/contemplative-reptile.jpg"
                  alt="green iguana"
                />
                <CardContent>
                  <Typography
                    gutterBottom
                    variant="h5"
                    textAlign={"center"}
                    component="div"
                  >
                    Lizard
                  </Typography>
                  <Typography variant="body2" color="text.secondary">
                    Lizards are a widespread group of squamate reptiles, with
                    over 6,000 species, ranging across all continents except
                    Antarctica
                  </Typography>
                </CardContent>
              </CardActionArea>
            </Card>
          </Box>
          <Box>
            <Card sx={{ maxWidth: 345 }}>
              <CardActionArea>
                <CardMedia
                  component="img"
                  height="140"
                  image="/static/images/cards/contemplative-reptile.jpg"
                  alt="green iguana"
                />
                <CardContent>
                  <Typography
                    gutterBottom
                    variant="h5"
                    textAlign={"center"}
                    component="div"
                  >
                    Lizard
                  </Typography>
                  <Typography variant="body2" color="text.secondary">
                    Lizards are a widespread group of squamate reptiles, with
                    over 6,000 species, ranging across all continents except
                    Antarctica
                  </Typography>
                </CardContent>
              </CardActionArea>
            </Card>
          </Box>
        </Box> */}
    </>
  );
};

export default Categories;
